import {
	OPEN_INTERNAL_WORKSPACE,
	CLOSE_INTERNAL_WORKSPACE,
} from '../actions/internal_workspace_actions';

const internalWorkspaceReducer = (oldState = { visible: false, activeTab: 'notes' }, action) => {
	Object.freeze(oldState);
	switch (action.type) {
		case OPEN_INTERNAL_WORKSPACE:
			return {
				...oldState,
				visible: true,
				activeTab: action.activeTab || 'notes',
			};
		case CLOSE_INTERNAL_WORKSPACE:
			return {
				...oldState,
				visible: false,
			};
		default:
			return oldState;
	}
};

export default internalWorkspaceReducer;
